export default __webpack_public_path__ + "static/media/view order.38c09c4a.jpg";